import { useSelector } from 'react-redux';
import {
  selectProducts,
  selectProductsIds
} from '../../../../store/products';
import { text } from '../../../../text';
import { ProductsList } from '../types';

const defaultListId = '1';
const unavailableForDeliveryListId = '2';
const outOfStockListId = '3';

export const useProductsLists = () => {
  const productsList: ProductsList[] = [
    { id: defaultListId, title: '', products: [] },
    {
      id: unavailableForDeliveryListId,
      title: text['productsList.unavailableForDelivery'],
      products: []
    },
    {
      id: outOfStockListId,
      title: text['productsList.outOfStock'],
      products: []
    }
  ];
  const products = useSelector(selectProducts);
  const productsIds = useSelector(selectProductsIds);

  productsIds.map((productId) => {
    productsList[0].products.push(products[productId]);
  });

  return productsList.filter(
    (list) => list.products.length > 0
  );
};
